// extracted by mini-css-extract-plugin
module.exports = {"block":"return_block__4MOS7","second":"return_second__2YV4T","link":"return_link__1SMGb"};